import { render } from "./CarouselImage.vue?vue&type=template&id=5b87c0c5"
import script from "./CarouselImage.vue?vue&type=script&lang=js"
export * from "./CarouselImage.vue?vue&type=script&lang=js"

import "./CarouselImage.vue?vue&type=style&index=0&id=5b87c0c5&lang=css"

import exportComponent from "/Users/don/phpStorm/qr-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__